import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AnnualInsurance } from '../../../models/quotation-model/catalogs/annual-insurance.model';

@Injectable({
  providedIn: 'root',
})
export class AnnualInsuranceService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getAnnualInsurances(
    insurancePayemntId: number,
    quotationId: number,
  ): Observable<AnnualInsurance[]> {
    return this.http.get<AnnualInsurance[]>(
      this.URL_API +
        '/AnnualInsurance?insurancePaymentId=' +
        insurancePayemntId +
        '&quotationId=' +
        quotationId,
    );
  }
}
